import { ButtonGroup } from '@atlaskit/button';
import Button from '@atlaskit/button/standard-button';
import { PrimaryCTA } from '@atlassian/amkt-common';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ConfirmCancelFooter = props => {
  return /*#__PURE__*/_jsxs(ButtonGroup, {
    children: [/*#__PURE__*/_jsx(Button, {
      appearance: "subtle-link",
      onClick: props.onClose,
      children: "Cancel"
    }), /*#__PURE__*/_jsx(PrimaryCTA, {
      testId: props.testId,
      href: props.href,
      isDisabled: props.isPrimaryDisabled,
      onClick: props.onPrimaryCTAClick,
      isLoading: props.isLoading,
      children: props.primaryCTALabel
    })]
  });
};